import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { handleToastError } from 'helpers';
import { getSelectedCentre } from 'store/master';
import reportApi from 'api/reportApi';
import { useUser } from '../../../hooks';
import { useSelector } from 'react-redux';
import { ArrowDown, ArrowUp } from 'react-feather';
import { getDarkMode } from 'store/settings';
const DonutChart = ({ totalClass }) => {
  const auth = useUser();
  const selectedCentre = useSelector(getSelectedCentre);
  const isDark = useSelector(getDarkMode);
  const [newcourses, setNewCourses] = useState();

  async function donutChartdetails() {
    try {
      const response = await reportApi.getDonutChartValue(
        auth?._id,
        selectedCentre?._id ? { courseCentre: selectedCentre?._id } : null,
      );
      setNewCourses(response);
    } catch (error) {
      handleToastError(error);
    }
  }
  useEffect(() => {
    donutChartdetails();
  }, [selectedCentre]);

  const disable =
    newcourses?.completedCourses ||
    newcourses?.coursesInProgress ||
    newcourses?.coursesNotStarted;

  const data = disable
    ? {
        labels: ['Completed', 'Inprogress', 'Not Started'],
        datasets: [
          {
            label: '# of Votes',
            data: [
              newcourses?.completedCourses,
              newcourses?.coursesInProgress,
              newcourses?.coursesNotStarted,
            ],
            backgroundColor: ['#43B58A', '#D6B409', '#3553A3'],
            borderColor: ['#43B58A', '#D6B409', '#3553A3'],
            borderWidth: 1,
          },
        ],
      }
    : {
        labels: ['Completed', 'Inprogress', 'Not Started'],
        datasets: [
          {
            label: '# of Votes',
            data: [1, 1, 1],
            backgroundColor: ['#c8c8c8', '#c8c8c8', '#c8c8c8'],
            borderColor: ['#c8c8c8', '#c8c8c8', '#c8c8c8'],
            borderWidth: 1,
          },
        ],
      };

  const options = {
    width: '50',
    height: '60',
    legend: {
      display: true,
      position: 'right',
      labels: {
        boxWidth: 25,
        fontColor: isDark ? '#b4b7bd' : '#6e6b7b',
      },
    },
    tooltips: {
      mode: !disable ? null : 'label',
      backgroundColor: isDark ? '#243040' : '#ffffff',
      titleFontColor: isDark ? '#b4b7bd' : '#6e6b7b',
      bodyFontColor: isDark ? '#b4b7bd' : '#6e6b7b',
      borderColor: isDark ? '#344054' : '#e2e8f0',
      borderWidth: 1,
    },
    hover: {
      mode: !disable ? null : 'label',
    },
    cutoutPercentage: 80,
  };

  return <Doughnut options={options} data={data} />;
};

export default DonutChart;
